import React from 'react';
import Slider from 'material-ui/Slider';

export default props =>
  <Slider
    {...props.inputProps}
    {...props.input}
    onChange={(event, value) => props.input.onChange(value == '' ? 0 : value)}
  />;



// WEBPACK FOOTER //
// src/modules/forms/components/SliderField.js